export const ro: Record<string, string> = {
  'Add': 'Adaugă',
  'Add user to favorites': 'Adaugă utilizatorul la favorite',
  'All time': 'Întreaga perioadă',
  'Around the point you selected': 'În jurul punctului selectat',
  'Around the visible map area': 'În zona vizibilă a hărții',
  'Back to map': 'Înapoi la hartă',
  'Back to sign in': 'Înapoi la autentificare',
  'Cancel manual location placement': 'Anulează amplasarea manuală',
  'Community map': 'Harta comunității',
  'Connecting to your device’s location signal…': 'Se conectează la semnalul de localizare al dispozitivului…',
  'Could not get your current location.': 'Locația curentă nu a putut fi obținută.',
  'Could not save this location. Please try again.': 'Locația nu a putut fi salvată. Încearcă din nou.',
  'Create account': 'Creează un cont',
  'Creating account…': 'Se creează contul…',
  'Dark Mode': 'Mod întunecat',
  'Enable location': 'Activează locația',
  'End': 'Sfârșit',
  'Failed to get location': 'Locația nu a putut fi obținută',
  'Failed to load application statistics.': 'Statisticile aplicației nu au putut fi încărcate.',
  'Failed to load map activity.': 'Activitatea hărții nu a putut fi încărcată.',
  'Failed to load statuses': 'Statusurile nu au putut fi încărcate',
  'Favorite person': 'Persoană favorită',
  'Favorite user': 'Utilizator favorit',
  'Find a person in direct messages': 'Găsește o persoană în mesajele directe',
  'Find a person…': 'Găsește o persoană…',
  'Getting location…': 'Se obține locația…',
  'Hide password': 'Ascunde parola',
  'Hide statuses': 'Ascunde statusurile',
  'Home': 'Acasă',
  'Join the map': 'Alătură-te hărții',
  'Last day': 'Ultima zi',
  'Last month': 'Ultima lună',
  'Last week': 'Ultima săptămână',
  'Light Mode': 'Mod luminos',
  'Like': 'Apreciază',
  'Liked': 'Apreciat',
  'Live location sharing is active.': 'Partajarea locației în timp real este activă.',
  'Load older messages': 'Încarcă mesaje mai vechi',
  'Loading older messages…': 'Se încarcă mesajele mai vechi…',
  'Manual location is active.': 'Locația manuală este activă.',
  'Map friend': 'Prieten pe hartă',
  'My statuses': 'Statusurile mele',
  'Nearby person': 'Persoană din apropiere',
  'Nearby statuses': 'Statusuri din apropiere',
  'New people': 'Persoane noi',
  'No nearby stories in this area yet': 'Nu există încă povești în apropiere',
  'No statuses found': 'Nu s-au găsit statusuri',
  'No stories shared yet': 'Nu s-au distribuit încă povești',
  'Place a manual location': 'Plasează manual o locație',
  'Profile': 'Profil',
  'Refresh map': 'Actualizează harta',
  'Remove': 'Elimină',
  'Remove user from favorites': 'Elimină utilizatorul din favorite',
  'Reply': 'Răspunde',
  'Save': 'Salvează',
  'Saved': 'Salvat',
  'Saving…': 'Se salvează…',
  'Search all direct messages': 'Caută în toate mesajele directe',
  'Search all messages…': 'Caută în toate mesajele…',
  'Search failed': 'Căutarea a eșuat',
  'Searching…': 'Se caută…',
  'Selected avatar': 'Avatar selectat',
  'Sending…': 'Se trimite…',
  'Set a manual location': 'Setează manual o locație',
  'Set here': 'Setează aici',
  'Set my location here': 'Setează locația mea aici',
  'Setting your location…': 'Se setează locația…',
  'Share Status': 'Distribuie statusul',
  'Shared from the map': 'Distribuit de pe hartă',
  'Sharing…': 'Se distribuie…',
  'Show password': 'Arată parola',
  'Show status location on map': 'Arată locația statusului pe hartă',
  'Signing in…': 'Se autentifică…',
  'Someone': 'Cineva',
  'Start a conversation': 'Începe o conversație',
  'Status details': 'Detalii despre status',
  'That status is no longer available.': 'Acest status nu mai este disponibil.',
  'The map is not ready yet.': 'Harta nu este încă pregătită.',
  'Time span': 'Interval de timp',
  'Unable to get your location': 'Locația nu a putut fi obținută',
  'Unfavorite user': 'Elimină utilizatorul din favorite',
  'Unknown User': 'Utilizator necunoscut',
  'Unlike': 'Retrage aprecierea',
  'User details': 'Detalii despre utilizator',
  'User information not available': 'Informațiile utilizatorului nu sunt disponibile',
  'View statuses': 'Vezi statusurile',
  'Waiting for a precise device location…': 'Se așteaptă o locație precisă a dispozitivului…',
  'What should nearby people know?': 'Ce ar trebui să știe persoanele din apropiere?',
  'What’s happening around you?': 'Ce se întâmplă în jurul tău?',
  'What’s happening, and when?': 'Ce se întâmplă și când?',
  'What’s the vibe, and where?': 'Care este atmosfera și unde?',
  'You': 'Tu',
  'Your location': 'Locația ta',
  'Your map location': 'Locația ta pe hartă',
  'Close menu': 'Închide meniul',
  'Close notifications': 'Închide notificările',
  'Close panel': 'Închide panoul',
  'Close search': 'Închide căutarea',
  'Close statistics': 'Închide statisticile',
  'Close status': 'Închide statusul',
  'Close user profile': 'Închide profilul utilizatorului',
  'Close user settings': 'Închide setările utilizatorului',
  'Dismiss error': 'Închide eroarea',
  'Dismiss welcome message': 'Închide mesajul de bun venit',
  'Opening your map…': 'Se deschide harta…',
  'Checking your map identity…': 'Se verifică identitatea ta pe hartă…',
  'Actions for this map point': 'Acțiuni pentru acest punct de pe hartă',
  'Avatar image URL': 'URL-ul imaginii avatarului',
  'Enter your display name': 'Introdu numele afișat',
  'Frame your avatar': 'Încadrează avatarul',
  'From': 'De la',
  'Here · 50 m': 'Aici · 50 m',
  'How people will see you': 'Cum te vor vedea ceilalți',
  'JPEG, PNG, or GIF up to 5 MB.': 'JPEG, PNG sau GIF de până la 5 MB.',
  'Move the map until the target is over the right place.': 'Mută harta până când ținta ajunge în locul potrivit.',
  'mapbl version': 'Versiunea mapbl',
  'About': 'Despre',
  'About mapbl': 'Despre mapbl',
  'About the service': 'Despre serviciu',
  'Account': 'Cont',
  'All stories': 'Toate poveștile',
  'Application statistics': 'Statisticile aplicației',
  'Area': 'Zonă',
  'Back to conversations': 'Înapoi la conversații',
  'Bio': 'Biografie',
  'Cancel': 'Anulează',
  'Choose your map position': 'Alege poziția ta pe hartă',
  'Choose your map vibe': 'Alege atmosfera ta pe hartă',
  'Clear': 'Șterge',
  'Community first': 'Comunitatea pe primul loc',
  'Connection interrupted': 'Conexiune întreruptă',
  'Could not locate you': 'Nu te-am putut localiza',
  'Create Status': 'Creează un status',
  'Create an account': 'Creează un cont',
  'Create status': 'Creează un status',
  'Create your identity': 'Creează-ți identitatea',
  'Crop Current Avatar': 'Decupează avatarul curent',
  'Direct Messages': 'Mesaje directe',
  'Direct messages': 'Mesaje directe',
  'Display Name': 'Nume afișat',
  'Display name': 'Nume afișat',
  'Edit': 'Editează',
  'Edit direct message': 'Editează mesajul direct',
  'Edit reply': 'Editează răspunsul',
  'Edited': 'Editat',
  'Email address': 'Adresă de e-mail',
  'Emoji collections': 'Colecții de emoji',
  'Favorites': 'Favorite',
  'Filter by status type': 'Filtrează după tipul statusului',
  'Finding your location': 'Se caută locația ta',
  'Go to my location': 'Mergi la locația mea',
  'Ignore user': 'Ignoră utilizatorul',
  'Ignored users': 'Utilizatori ignorați',
  'Jump to latest messages': 'Mergi la cele mai recente mesaje',
  'Last 24 hours': 'Ultimele 24 de ore',
  'Last hour': 'Ultima oră',
  'Link (optional)': 'Link (opțional)',
  'Live map stories': 'Povești live de pe hartă',
  'Load more results': 'Încarcă mai multe rezultate',
  'Load older': 'Încarcă mai vechi',
  'Loading favorites…': 'Se încarcă favoritele…',
  'Loading messages…': 'Se încarcă mesajele…',
  'Loading statuses': 'Se încarcă statusurile',
  'Loading user data...': 'Se încarcă datele utilizatorului…',
  'Loading…': 'Se încarcă…',
  'Locating you': 'Se caută locația ta',
  'Map': 'Hartă',
  'Map navigation': 'Navigarea pe hartă',
  'Mark all read': 'Marchează totul ca citit',
  'Message': 'Mesaj',
  'Message *': 'Mesaj *',
  'Messages': 'Mesaje',
  'My Location': 'Locația mea',
  'My Statuses': 'Statusurile mele',
  'Nearby Statuses': 'Statusuri din apropiere',
  'Nearby activity': 'Activitate în apropiere',
  'Nearby radius': 'Rază de proximitate',
  'New status': 'Status nou',
  'No matching messages found.': 'Nu s-au găsit mesaje potrivite.',
  'No notifications yet': 'Nicio notificare încă',
  'Notifications': 'Notificări',
  'Notification settings': 'Setări pentru notificări',
  'Number of statuses': 'Număr de statusuri',
  'Open shared link': 'Deschide linkul distribuit',
  'Password': 'Parolă',
  'People': 'Persoane',
  'People and statuses you saved': 'Persoane și statusuri salvate',
  'Posted': 'Publicat',
  'Privacy & play': 'Confidențialitate și joc',
  'Privacy Policy': 'Politica de confidențialitate',
  'Private conversation': 'Conversație privată',
  'Private conversations': 'Conversații private',
  'Profile settings': 'Setări de profil',
  'Ready to upload': 'Pregătit pentru încărcare',
  'Recent': 'Recente',
  'Recent searches': 'Căutări recente',
  'Refresh': 'Actualizează',
  'Refresh statuses': 'Actualizează statusurile',
  'Reload mapbl': 'Reîncarcă mapbl',
  'Reply to status': 'Răspunde la status',
  'Search a wider area': 'Caută într-o zonă mai largă',
  'Selected map point': 'Punct selectat pe hartă',
  'Selected period': 'Perioadă selectată',
  'Send direct message': 'Trimite mesaj direct',
  'Settings': 'Setări',
  'Share nearby': 'Distribuie în apropiere',
  'Short bio': 'Biografie scurtă',
  'Show': 'Arată',
  'Sign in': 'Autentificare',
  'Sign in to mapbl': 'Autentifică-te în mapbl',
  'Start must be before end.': 'Începutul trebuie să fie înaintea sfârșitului.',
  'Status reply': 'Răspuns la status',
  'Statuses': 'Statusuri',
  'Stop ignoring': 'Nu mai ignora',
  'Surprise me': 'Surprinde-mă',
  'Surprise me with an emoji': 'Surprinde-mă cu un emoji',
  'Time': 'Timp',
  'Time filter': 'Filtru de timp',
  'Time span end': 'Sfârșitul intervalului',
  'Time span start': 'Începutul intervalului',
  'To': 'Până la',
  'Toggle menu': 'Deschide sau închide meniul',
  'Try again': 'Încearcă din nou',
  'Unread': 'Necitit',
  'Updated': 'Actualizat',
  'Use a photo': 'Folosește o fotografie',
  'Use an image URL instead': 'Folosește în schimb URL-ul unei imagini',
  'Use emoji': 'Folosește emoji',
  'Use this crop': 'Folosește această decupare',
  'What are you sharing?': 'Ce distribui?',
  'Width': 'Lățime',
  'Write a direct message': 'Scrie un mesaj direct',
  'Write a message…': 'Scrie un mesaj…',
  'Write a reply…': 'Scrie un răspuns…',
  'You are not ignoring anyone.': 'Nu ignori pe nimeni.',
  'Your map identity': 'Identitatea ta pe hartă',
  'Your password': 'Parola ta',
  'Your recent posts and moments': 'Postările și momentele tale recente',
  'You’re on the map': 'Ești pe hartă',
  'Zoom': 'Zoom',
  'edited': 'editat',
  'latest': 'cele mai recente',
  'optional': 'opțional',
  'statuses': 'statusuri',
  'sent you a message': 'ți-a trimis un mesaj',
  'replied to your status': 'a răspuns la statusul tău',
  'Just now': 'Chiar acum',
  'Statuses (': 'Statusuri (',
  'Users (': 'Utilizatori (',
  'people ·': 'persoane ·',
  'Failed to update profile': 'Profilul nu a putut fi actualizat',
  'Failed to upload avatar': 'Avatarul nu a putut fi încărcat',
  'Failed to log out': 'Deconectarea a eșuat',
  'Please select a valid image file (JPEG, PNG, GIF)': 'Selectează un fișier imagine valid (JPEG, PNG sau GIF)',
  'File size must be less than 5MB': 'Fișierul trebuie să fie mai mic de 5 MB',
  'Geolocation is not supported by this browser': 'Acest browser nu acceptă geolocalizarea',
  'Location permission denied': 'Permisiunea de localizare a fost refuzată',
  'Location unavailable': 'Locație indisponibilă',
  'A fantasy map made for fun': 'O hartă fantastică creată pentru distracție',
  'A little about you': 'Câte ceva despre tine',
  'Bright, friendly, and a little futuristic.': 'Luminos, prietenos și puțin futurist.',
  'Tell us about yourself': 'Spune-ne despre tine',
  'What other players can see': 'Ce pot vedea ceilalți jucători',
  'Your choices': 'Alegerile tale',
  '5 seconds': '5 secunde',
  '10 seconds': '10 secunde',
  'A quick heads-up': 'O scurtă notificare',
  'Recommended': 'Recomandat',
  'Never': 'Niciodată',
  'Keep markers still': 'Păstrează marcajele nemișcate',
  'Until I open it': 'Până când îl deschid',
  'Animate until selected': 'Animează până la selectare',
  'Uploading…': 'Se încarcă…',
  'Upload avatar': 'Încarcă avatarul',
  'Logging out…': 'Se deconectează…',
  'Logout': 'Deconectare',
  'Updating…': 'Se actualizează…',
  'Update Profile': 'Actualizează profilul',
  'Language': 'Limbă',
  'Interface language': 'Limba interfeței',
  'English': 'Engleză',
  'Ukrainian': 'Ucraineană',
  'Spanish': 'Spaniolă',
  'French': 'Franceză',
  'Norwegian': 'Norvegiană',
  'Dutch': 'Neerlandeză',
  'Romanian': 'Română',
  'Profile updated successfully!': 'Profilul a fost actualizat cu succes!',
  'Avatar uploaded successfully!': 'Avatarul a fost încărcat cu succes!',
  'Welcome back': 'Bine ai revenit',
  'New to mapbl?': 'Ești nou pe mapbl?',
  'Already on mapbl?': 'Ai deja un cont mapbl?',
  'Password is required': 'Parola este obligatorie',
  'Email is required': 'Adresa de e-mail este obligatorie',
  'Enter a valid email address': 'Introdu o adresă de e-mail validă',
  'At least 6 characters': 'Cel puțin 6 caractere',
  'People and statuses could not be refreshed. Your current map view is still available.': 'Persoanele și statusurile nu au putut fi actualizate. Vizualizarea curentă a hărții este încă disponibilă.',
  'Reconnecting people and nearby stories…': 'Se reconectează persoanele și poveștile din apropiere…',
  'Set your map location to make this status discoverable nearby.': 'Setează locația pe hartă pentru ca acest status să poată fi descoperit în apropiere.',
  'The point you selected on the map will be attached to this status.': 'Punctul selectat pe hartă va fi atașat acestui status.',
  "This user hasn't posted any statuses yet": 'Acest utilizator nu a publicat încă niciun status',
  'Your current map location will be attached so nearby people can discover it.': 'Locația ta curentă pe hartă va fi atașată pentru ca persoanele din apropiere să îți poată descoperi statusul.',
  'Close about mapbl': 'Închide informațiile despre mapbl',
  'Close cluster details': 'Închide detaliile grupului',
  'Close create status dialog': 'Închide fereastra de creare a statusului',
  'Close details': 'Închide detaliile',
  'Close direct messages': 'Închide mesajele directe',
  'Close favorites': 'Închide favoritele',
  'Close map actions': 'Închide acțiunile hărții',
  'Close map details': 'Închide detaliile hărții',
  'Close statuses dialog': 'Închide lista de statusuri',
  'Dismiss about mapbl': 'Ascunde informațiile despre mapbl',
  'Dismiss create status dialog': 'Ascunde fereastra de creare a statusului',
  'Dismiss map pulse': 'Ascunde pulsul hărții',
  'Dismiss my statuses': 'Ascunde statusurile mele',
  'Dismiss nearby statuses': 'Ascunde statusurile din apropiere',
  'Dismiss profile settings': 'Ascunde setările profilului',
  'Dismiss status error': 'Ascunde eroarea statusului',
  'Avatar crop zoom': 'Zoom pentru decuparea avatarului',
  'Changes to this policy': 'Modificări ale acestei politici',
  'Effective September 7, 2026': 'În vigoare din 7 septembrie 2026',
  'How information is used': 'Cum sunt utilizate informațiile',
  'Information used by the game': 'Informații utilizate de joc',
  'Map content is not verified. Treat every status, identity, and location as fictional game content—not fact.': 'Conținutul hărții nu este verificat. Consideră fiecare status, identitate și locație drept conținut fictiv al jocului, nu drept fapt real.',
  'Maps and service providers': 'Hărți și furnizori de servicii',
  'OpenStreetMap copyright and attribution': 'Drepturi de autor și atribuire OpenStreetMap',
  'mapbl is a fantasy experience for fun.': 'mapbl este o experiență fantastică pentru distracție.',
  'mapbl is a playful social map where you can share what is happening, discover nearby statuses, and see the community come alive around you.': 'mapbl este o hartă socială distractivă unde poți distribui ce se întâmplă, descoperi statusuri din apropiere și vedea comunitatea prinzând viață în jurul tău.',
  'mapbl is a game and creative social experience. Names, profiles, locations, statuses, events, announcements, and other content shown on the map are user-submitted, are not independently verified, and must not be treated as statements of fact. Everything you see should be understood as fictional, role-play, or fantasy content created for entertainment only.': 'mapbl este un joc și o experiență socială creativă. Numele, profilurile, locațiile, statusurile, evenimentele, anunțurile și celelalte elemente afișate pe hartă sunt trimise de utilizatori, nu sunt verificate independent și nu trebuie considerate afirmații factuale. Tot ce vezi trebuie înțeles drept conținut fictiv, de rol sau fantastic, creat exclusiv pentru divertisment.',
  'We process only the information needed to provide the experience: account details you submit, such as your email, display name, bio, avatar, and password in protected hashed form; statuses and reactions you create; a browser-selected or manually selected map location; and sign-in tokens stored on your device. This information is saved only so the game can operate and remember your account and game activity.': 'Prelucrăm doar informațiile necesare pentru a oferi experiența: datele contului pe care le trimiți, precum adresa de e-mail, numele afișat, biografia, avatarul și parola în formă hash protejată; statusurile și reacțiile create; o locație selectată de browser sau manual pe hartă; și tokenurile de autentificare stocate pe dispozitiv. Aceste informații sunt salvate doar pentru funcționarea jocului și păstrarea contului și activității tale.',
  'Submitted information is used only to authenticate you, display and personalize the map, show game content, support nearby discovery, and maintain the service. mapbl does not sell your personal information or use your game activity to make real-world claims about you.': 'Informațiile trimise sunt utilizate doar pentru autentificare, afișarea și personalizarea hărții, prezentarea conținutului jocului, descoperirea în apropiere și întreținerea serviciului. mapbl nu vinde informațiile tale personale și nu folosește activitatea ta din joc pentru afirmații despre tine în lumea reală.',
  'The experience is built around a shared map. Your chosen game identity, avatar, bio, approximate or selected location, statuses, and reactions may be visible to other players. Your password and authentication tokens are not displayed to other players. Do not use real-world secrets, sensitive personal details, or a precise real-world location in your public game content.': 'Experiența este construită în jurul unei hărți comune. Identitatea de joc aleasă, avatarul, biografia, locația aproximativă sau selectată, statusurile și reacțiile pot fi vizibile altor jucători. Parola și tokenurile de autentificare nu sunt afișate celorlalți. Nu folosi secrete reale, date personale sensibile sau o locație reală precisă în conținutul public al jocului.',
  'The site may rely on hosting, map, and geocoding providers to deliver the service. Those providers may receive ordinary technical requests, such as an IP address and map coordinates, under their own privacy terms. We limit access to stored information to what is necessary to operate and protect the game.': 'Site-ul poate utiliza furnizori de găzduire, hărți și geocodare pentru a oferi serviciul. Acești furnizori pot primi solicitări tehnice obișnuite, precum adresa IP și coordonatele hărții, conform propriilor condiții de confidențialitate. Limităm accesul la informațiile stocate la ceea ce este necesar pentru operarea și protejarea jocului.',
  'You choose what identity, status, and location to submit. You can update your profile and game content through the available controls, stop sharing a browser location by changing your browser permissions, and sign out to remove sign-in tokens from the device. Please contact the site operator if you need help with your account or stored information.': 'Tu alegi ce identitate, status și locație trimiți. Îți poți actualiza profilul și conținutul jocului folosind comenzile disponibile, poți opri partajarea locației modificând permisiunile browserului și te poți deconecta pentru a elimina tokenurile de autentificare de pe dispozitiv. Contactează operatorul site-ului dacă ai nevoie de ajutor privind contul sau informațiile stocate.',
  'We may update this policy as the game changes. The effective date at the top will be revised when that happens. Continued use of mapbl after an update means you accept the revised policy.': 'Putem actualiza această politică pe măsură ce jocul se schimbă. Data intrării în vigoare de mai sus va fi revizuită atunci când se întâmplă acest lucru. Continuarea utilizării mapbl după o actualizare înseamnă că accepți politica revizuită.',
  'Favorite people or statuses to keep them close.': 'Adaugă persoane sau statusuri la favorite pentru a le păstra aproape.',
  'Filter profile statuses': 'Filtrează statusurile profilului',
  'Filter the signal': 'Filtrează semnalul',
  'Live community signal': 'Semnalul live al comunității',
  'Load older replies': 'Încarcă răspunsuri mai vechi',
  'Loading ignored users…': 'Se încarcă utilizatorii ignorați…',
  'Loading replies…': 'Se încarcă răspunsurile…',
  'Location needs attention': 'Locația necesită atenție',
  'Make it yours': 'Personalizează-l',
  'Map avatar preview': 'Previzualizarea avatarului pe hartă',
  'Map discovery': 'Descoperire pe hartă',
  'Map pulse': 'Pulsul hărții',
  'Map refresh paused': 'Actualizarea hărții este întreruptă',
  'No people found in your direct messages.': 'Nu s-au găsit persoane în mesajele tale directe.',
  'Nothing shared in this cluster yet': 'Nu s-a distribuit încă nimic în acest grup',
  'Observe nearby statuses': 'Urmărește statusurile din apropiere',
  'People make the map': 'Oamenii dau viață hărții',
  'Post a new status or message here': 'Publică aici un status sau un mesaj nou',
  'Reading the map pulse…': 'Se citește pulsul hărții…',
  'Refreshing the map': 'Se actualizează harta',
  'Replies and direct messages': 'Răspunsuri și mesaje directe',
  'Say hello to start the conversation.': 'Spune salut pentru a începe conversația.',
  'Search every message in your direct conversations.': 'Caută în toate mesajele din conversațiile tale directe.',
  'Select a conversation to read your messages.': 'Selectează o conversație pentru a-ți citi mesajele.',
  'The map hit a rough patch': 'Harta a întâmpinat o problemă',
  'or set it manually on the map': 'sau seteaz-o manual pe hartă',
  'Failed to load current avatar image for cropping': 'Avatarul curent nu a putut fi încărcat pentru decupare',
  'Geolocation is not supported by this browser.': 'Acest browser nu acceptă geolocalizarea.',
  'Location permission denied. Please enable location access in your browser settings.': 'Permisiunea de localizare a fost refuzată. Activează accesul la locație în setările browserului.',
  'Location request timed out. Please try again.': 'Solicitarea locației a expirat. Încearcă din nou.',
  'Location tracking failed': 'Urmărirea locației a eșuat',
  'Location tracking timed out': 'Urmărirea locației a expirat',
  'Location unavailable. Please check your GPS or network connection.': 'Locația nu este disponibilă. Verifică GPS-ul sau conexiunea la rețea.',
  'A quick look at how the community is moving.': 'O privire rapidă asupra activității comunității.',
  'Choose a photo or an upbeat emoji. This is how people recognize you on the map.': 'Alege o fotografie sau un emoji vesel. Așa te recunosc oamenii pe hartă.',
  'Choose how long new live locations and statuses animate on the map.': 'Alege cât timp se animează pe hartă locațiile și statusurile live noi.',
  'Choose someone on the map to start a conversation.': 'Alege pe cineva de pe hartă pentru a începe o conversație.',
  'Drag to position, then fine-tune the zoom.': 'Trage pentru poziționare, apoi ajustează fin zoomul.',
  'Find the bright moments happening around you.': 'Descoperă momentele frumoase care se petrec în jurul tău.',
  'Share a location, leave a status, and discover the people and energy nearby.': 'Distribuie o locație, publică un status și descoperă oamenii și energia din apropiere.',
  'Sign out of mapbl on this device.': 'Deconectează-te de la mapbl pe acest dispozitiv.',
  'Their locations, statuses, and direct messages are hidden both ways.': 'Locațiile, statusurile și mesajele directe sunt ascunse în ambele sensuri.',
  'Your map, people, and nearby moments are waiting.': 'Harta, oamenii și momentele din apropiere te așteaptă.',
  'Your account and map data are safe. Reload mapbl to reconnect and pick up where you left off.': 'Contul și datele hărții sunt în siguranță. Reîncarcă mapbl pentru a te reconecta și a continua de unde ai rămas.',
};
